module.exports = __webpack_public_path__ + "static/media/Launch.972ac66e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Icons/Launch.svg
// module id = 249
// module chunks = 0